<template>
	<a-tag :color="color">
		{{ value }}
	</a-tag>
</template>

<script>
export default {
	name: 'GTableSlotSelect',
	props: {
		item: {
			type: Number,
			required: true
		},
		index: {
			type: String,
			required: true
		},
		app: {
			type: String,
			required: true
		}
	},
	computed: {
		value() {
			const value = this.$gestios.$utils.getValue(this.app, this.index, this.item);
			return value;
		},
		color() {
			switch (this.item) {
				case 0:
					return 'blue';

				case 1:
					return 'green';

				case 2:
					return 'red';

				case 3:
					return 'orange';

				case 4:
					return 'cyan';

				case 5:
					return 'purple';

				default:
					return 'pink';
			}
		}
	}
};
</script>

<style lang="scss" scoped>

</style>
